<template>
  <section v-if="isActive">
    <SkeletonView height="50" />
    <div class="m-t-30">
      <SkeletonView height="20" width="75%" />
    </div>
    <div class="m-t-50 m-b-50">
      <SkeletonView height="200" />
    </div>
    <div class="columns is-mobile">
      <div class="column is-6">
        <SkeletonView height="45" width="100" />
      </div>
      <div class="column is-6">
        <div class="is-pulled-right">
          <SkeletonView height="45" width="100" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import SkeletonView from '@/modules/core/ui/components/wrappers/SkeletonView.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'FlowModalSkeleton',
  components: { SkeletonView },
  props: {
    isActive: {
      type: Boolean,
      default: false
    }
  }
};
</script>
